<template>
  <el-dialog class="rc-dialog" :title="curdTitle" :visible.sync="CUFlag" @close="closeDialog"
    :close-on-click-modal="false" destroy-on-close width="50%">
    <el-form ref="curdForm" size="small" :model="curdForm" :rules="rules" label-position="right" label-width="120px">
      <el-row :gutter="12">
        <el-col>
          <el-form-item>
            <butn btntype="primary" title="下载模板" @click="downloadTemplate"></butn>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item required label="附件：" error="请上传附件" :show-message="file == null">
            <upload v-model="file" :accepts="['excel']" ref="removeFile" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import Upload from "@/components/upload/excel";
import { dailyScheduleTemplate } from "@/assets/excel/index.js";
import { importCourse } from "@/api/class";
import { downloadByUrl } from "@/utils/common";

export default {
  components: { butn, Upload },
  data() {
    return {
      EXCP: dailyScheduleTemplate,
      Bus,
      rules: {
      },
      curdTitle: "",
      CUFlag: false,
      file: null,
      curdForm: {
        workCredit: 0,
        isRequired: 1,
        allowRemedy: 1,
        remedyCredit: 0,
        attachment: "",
        attachmentList: []
      },
      classId: ""
    };
  },
  created() {

  },

  methods: {

    showImport(item) {
      this.curdTitle = "导入日程安排";
      this.classId = item.classId
      this.CUFlag = true;
      this.curdForm.attachmentList = [];
    },
    //提交数据
    createData() {
      if (this.file != null) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("classId", this.classId);
        importCourse(formData).then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            if (res.data == null) {
              this.$message.success(res.msg);
              this.closeDialog();
              this.$parent.getScheduleList();
            } else {
              this.$message.error("导入包含错误数据，请检查");
              this.$router.push({
                path: "/excelError",
              });
              localStorage.setItem("errorExcelData", JSON.stringify(res.data));
            }
          } else {
            this.$refs.removeFile.$refs.upload.uploadFiles.pop();
            this.file = null;
          }
        });
      }
    },
    closeDialog() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    },
    downloadTemplate() {
      downloadByUrl(null, this.EXCP);
    }
  }
};
</script>

<style lang="scss" scoped></style>
